import oneLineDiagramSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const oneLineDiagActions = { ...actions, ...thunkActions };
export * as OneLineDiagTypes from './types';
export default oneLineDiagramSlice;
